import { render, staticRenderFns } from "./buscarClientes.vue?vue&type=template&id=0d700668&scoped=true&"
import script from "./buscarClientes.vue?vue&type=script&lang=js&"
export * from "./buscarClientes.vue?vue&type=script&lang=js&"
import style0 from "./buscarClientes.vue?vue&type=style&index=0&id=0d700668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d700668",
  null
  
)

export default component.exports